import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
/* Lazy-load EVERYTHING below the hero to keep the initial JS bundle minimal.
   TrustBar lives below the hero fold on most mobile viewports, so lazying it
   is safe and shaves more JS off the critical path. */
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-272">
      {/* Above-fold: eager for fastest LCP */}
      <HeroSection data-id="element-273" />

      {/* Near-fold — everything from TrustBar down is lazy + content-visibility:auto */}
      <Suspense fallback={null} data-id="element-274">
        <div className="cv-auto" data-id="element-275">
          <TrustBar data-id="element-276" />
          <ContrastSection data-id="element-277" />
          <ForWhomSection data-id="element-278" />
          <BenefitsSection data-id="element-279" />
          <PricingSection data-id="element-280" />
        </div>
      </Suspense>

      {/* Far below fold */}
      <Suspense fallback={null} data-id="element-281">
        <div className="cv-auto" data-id="element-282">
          <GuaranteeSection data-id="element-283" />
          <TestimonialsSection data-id="element-284" />
          <ExpertSection data-id="element-285" />
          <FAQSection data-id="element-286" />
          <Footer data-id="element-287" />
        </div>
        <SocialProofPopup data-id="element-288" />
      </Suspense>

      <StickyCTA data-id="element-289" />
    </main>;
}